<template>
  <div
    v-if="shouldRenderConfig"
    v-show="!getMatrixComplete"
    :class="getClassName"
  >
    <appPageOptionContainer></appPageOptionContainer>
    <appPageOptionAllAttributesContainer></appPageOptionAllAttributesContainer>
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useConfigStore } from "@/stores/modules/config";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useConfigStore, ["getMatrixComplete"]),
    ...mapState(useWebproductStore, ["getActiveProductPageOptions"])
  },

  methods: {
    getProductPageOptionValues: function (pageOption) {
      return this.getActiveProductPageOptions[pageOption].values;
    }
  }
};
</script>
